export default __webpack_public_path__ + "media/images/app-icon-0808256a4b7b3a7d337085d90c1b6133.svg";